module.exports = __webpack_public_path__ + "static/feature_bg3-d19aec0db11e5dc6684d433be147307a.png";